export const NAV_ITEMS = [
  { href: "status-section", label: "HEADER_COLOR_TO_LIFE" },
  { href: "technical-section", label: "HEADER_TECHNICAL" },
  { href: "case-section", label: "HEADER_CASE" },
  { href: "market-section", label: "HEADER_MARKET" },
  { href: "business-section", label: "HEADER_BUSINESS" },
  { href: "investment-section", label: "HEADER_INVESTMENT" },
] as const;
